import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { EduContent } from '@campus/dal';
import { CONTENT_OPEN_ACTIONS_SERVICE_TOKEN, EduContentSearchResultInterface } from '@campus/shared';
import '@diekeure/dcr-components/dcr-section.js';
import { Category } from '../../interfaces/toc-result-service.interface';

@Component({
    selector: 'campus-toc-result-display-item',
    templateUrl: './toc-result-display-item.component.html',
    styleUrls: ['./toc-result-display-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TocResultDisplayItemComponent {
  @Input() category: Category;
  @Input() trackById: (index: number, item: any) => any;
  @Input() trackByEduContentId: (index: number, item: EduContentSearchResultInterface) => any;

  private contentOpenActionsService = inject(CONTENT_OPEN_ACTIONS_SERVICE_TOKEN);

  openWebApp(eduContent: EduContent): void {
    const action = this.contentOpenActionsService.getActionForContent(eduContent, 'openEduContentAsWebApp');

    if (action?.handler) {
      action.handler(eduContent);
    }
  }
}
